import { Injectable } from '@angular/core';
import { DatabaseService } from '../alcance/services/database.service';
import * as moment from 'moment';
import { DatabaseIndice, DatabaseRelation } from '../alcance/interfaces/database';
import { Atividade } from '../models/atividade';

@Injectable({
  providedIn: 'root'
})
export class AtividadeDBService extends DatabaseService{
    override classname: string = 'AtividadeDBService';
    override table = 'atividade';
    override keyPath = 'uuid';
    override typeKey = 'TEXT';
    protected override useUuidKey = true;

    override indices: DatabaseIndice[] = [
        {name: "by_id", field: "id", unique: false, multiEntry: false},
        {name: "by_edificacao", field: "edificacao_id", unique: false, multiEntry: false},
        {name: "by_descricao", field: "descricao", unique: false, multiEntry: false},
        {name: "by_controle", field: "controle", unique: false, multiEntry: false },
        {name: "by_status", field: "status", unique: false, multiEntry: false},
        {name: "by_categoria", field: "equipamento.categoria_id", unique: false, multiEntry: false},
        {name: "by_tipo", field: "equipamento.tipo_id", unique: false, multiEntry: false},
        {name: "by_tipos", field: "equipamento.tipos.id", unique: false, multiEntry: true},
        {name: "by_andar", field: "andar_id", unique: false, multiEntry: false},
        {name: "by_grupo", field: "grupos.id", unique: false, multiEntry: true},
        {name: "by_sinc", field: "sinc", unique: false, multiEntry: false}
    ];

    //MIGRACOES DE DADOS
    protected override migration = 7;

    protected override relations: DatabaseRelation[] = [
        // {name: 'edificacao', table: 'edificacao', field: 'edificacao_id', type: 'foreign'}, // só deixa lento, e o app não usa ja pega do usuario
        {name: 'equipamento', table: 'equipamento', field: 'equipamento_id', type: 'foreign', key:'equipamento'},
        {name: 'andar', table: 'andar', field: 'andar_id', type: 'foreign'},
        {name: 'usuario', table: 'usuario', field: 'usuario_id', type: 'foreign'}
    ];

    protected override defineObj(obj: Atividade){
        obj.realizada_em = obj.realizada_em ? (moment as any)(obj.realizada_em).format("YYYY-MM-DD HH:mm:ss"): undefined;
        return obj;
    };

    protected override filterSql(sql: string, params: any): string {
        if(params?.descricao){
            if(sql.indexOf('WHERE') == -1)
                sql += ' WHERE';
            else
                sql += ' AND';

            sql += " by_descricao LIKE '%" + params.descricao + "%'";
        }
        if(params?.controle){
            if(sql.indexOf('WHERE') == -1)
                sql += ' WHERE';
            else
                sql += ' AND';

            sql += " by_controle LIKE '" + params.controle + "'";
        }
        if(params?.andar_id){
            if(sql.indexOf('WHERE') == -1)
                sql += ' WHERE';
            else
                sql += ' AND';

            sql += " by_andar = '" + params.andar_id + "'";
        }
        if(params?.categoria_id){
            if(sql.indexOf('WHERE') == -1)
                sql += ' WHERE';
            else
                sql += ' AND';

            sql += " by_categoria = '" + params.categoria_id + "'";
        }
        if(params?.tipo_id){
            if(sql.indexOf('WHERE') == -1)
                sql += ' WHERE';
            else
                sql += ' AND';

            const tipoId = params.tipo_id;
            sql += " (by_tipo = '" + tipoId + "' OR EXISTS (SELECT 1 FROM atividade_by_tipos multi_entry WHERE multi_entry.foreign_uuid = atividade.uuid AND multi_entry.by_tipos = '" + tipoId + "'))";
        }
        if(params?.status){
            if(sql.indexOf('WHERE') == -1)
                sql += ' WHERE';
            else
                sql += ' AND';

            sql += " by_status = '" + params.status + "'";
        }

        const grupos = (Array.isArray(params?.['grupos[]']) ? params['grupos[]'] : [])
            .map((id: any) => Number(id))
            .filter((id: number) => Number.isInteger(id) && id > 0);

        sql = this.filterMultiEntry(sql, 'by_grupo', grupos);

        return sql;
    }
}
